import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useAdminAuth } from "../contexts/AdminAuthContext";
import AppSwitcher, { AppSwitcherMobile } from "../../my/components/AppSwitcher";
import useSidebarCollapsed from "../../shared/useSidebarCollapsed";
import useAdminTables from "./layout/useAdminTables";
import AdminHeader from "./layout/AdminHeader";
import AdminSidebar from "./layout/AdminSidebar";
import usePushSounds from "../../hooks/usePushSounds";

export default function AdminLayout() {
  const { user, loading, logout } = useAdminAuth();
  const [mobileNav, setMobileNav] = useState(false);
  const [collapsed, toggleCollapsed] = useSidebarCollapsed("admin_sidebar_collapsed");
  const nav = useNavigate();
  const tables = useAdminTables({ user });
  usePushSounds();

  useEffect(() => {
    if (!loading && !user) nav("/admin/login", { replace: true });
  }, [loading, user, nav]);

  if (loading || !user) {
    return <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center text-sm text-[#4B5563]">A carregar...</div>;
  }

  const doLogout = async () => { await logout(); nav("/admin/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#F5F2EB] text-[#0F1829]" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <AppSwitcher current="admin" isConsultor={!!user?.IsConsultor} isDBAdmin theme="light" />
      <AppSwitcherMobile current="admin" isConsultor={!!user?.IsConsultor} isDBAdmin theme="light" />

      <AdminHeader
        user={user}
        collapsed={collapsed} toggleCollapsed={toggleCollapsed}
        onOpenMobileNav={() => setMobileNav(true)}
        onLogout={doLogout}
      />

      <div className="flex lg:pl-[72px] pb-[72px] lg:pb-0">
        {mobileNav && (
          <div className="lg:hidden fixed inset-0 bg-black/40 z-30"
            onClick={() => setMobileNav(false)} data-testid="admin-nav-backdrop" />
        )}
        <AdminSidebar
          collapsed={collapsed} onExpand={toggleCollapsed}
          mobileNav={mobileNav} setMobileNav={setMobileNav}
          search={tables.search} setSearch={tables.setSearch}
          filtered={tables.filtered} tables={tables.tables}
          sectionGroups={tables.sectionGroups} schemas={tables.schemas}
        />
        <main className="flex-1 min-w-0 p-4 sm:p-5 md:p-8 overflow-x-hidden" data-testid="admin-content">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors closeButton duration={8000} />
    </div>
  );
}
